import Api from './Api';

const END_POINT = 'customers'

export default {
    async get_all(filters = null) {        
        let request = {
            params: filters
        }
        return await Api.get(`${END_POINT}`, request)
    },
    async get_allPaginated(filters = null) {
        let request = {
            params: filters
        }
        return await Api.get(`${END_POINT}-list-paginated`, request);
    },
    async store(customer) {
        return await Api.post(`${END_POINT}`, customer)
    },
    async update(customer) {
        return await Api.patch(`${END_POINT}/${customer.id}`, customer)
    },
    async change_status(customer) {
        return await Api.patch(`${END_POINT}/${customer.id}/change-status`, customer)
    },
    async delete(customer) {
        return await Api.delete(`${END_POINT}/${customer.id}`, customer)
    },
    async search_document (document) {
        return await Api.get(`https://apispa.wost.pe/api/customers/${document}/search-document`)
    },
    download(filters = null) {
        let request = {
            params: filters
        }
        return Api.get(`${END_POINT}/download-customers`, request);
    },
    async upload(customer) {
        const config = {
          headers: {
            "content-type": "multipart/form-data",
          },
        };
        return Api.post(`${END_POINT}/upload`, customer, config);
    }
}